import { httpUtil } from "./httpUtil";
import { createCommonResult, createResult, ErrorCodes } from "./resultUtil";

export const account = {
    getWalletInfo,
    getPrimaryAccount,
    getAccountJournals,
    getJournal,
}

async function getWalletInfo(accountId) {
    try {
        if (!accountId) {
            let primeAccRes = await getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/accounts/' + accountId + '/financials',
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPrimaryAccount() {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: '/v1/contacts/' + id + '/accounts',
            queryParams: { is_primary: true },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception register: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getAccountJournals({
    accountId,
    page = 1,
    size = 10,
    order, //='DESC'
    from_date,
    to_date, //epoch time
    transaction_type
}) {
    try {
        if (!accountId) {
            let primeAccRes = await getPrimaryAccount();
            if (primeAccRes.code != ErrorCodes.OK)
                return primeAccRes;
            if (!primeAccRes.data.content && primeAccRes.data.content.size() == 0)
                return createResult(ErrorCodes.ACCOUNT_NOT_FOUND, response.error);
            accountId = primeAccRes.data.content[0].id;
        }
        let query = {
            page,
            size,
            order,
            transaction_type,
        };
        if(from_date){
            query["posted_on[gte]"] = from_date;
        }
        if(to_date){
            query["posted_on[lte]"] = to_date;
        }
        let response = await httpUtil.get({
            resourcePath: '/v1/accounts/' + accountId + '/journals',
            queryParams: query,
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getAccountJournals: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getJournal(invoiceId) {
    try {
        let response = await httpUtil.get({
            resourcePath: '/v1/journals/' + invoiceId,
            queryParams:{
                include_lines: true
            },
            withAccessToken: true
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log('Exception getJournal: ', e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}